import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: absolute;\n\tright: ", ";\n\ttop: 50%;\n\n\ttransform: translate(0, -50%);\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tfont-weight: 600;\n\tleft: 50%;\n\tline-height: 1;\n\tmargin: 0;\n\tmax-width: 60%;\n\tposition: absolute;\n\ttop: 50%;\n\ttransform: translate(-50%, -50%);\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: relative;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, styled, ui } from '@wp-g2/styles';
export var ModalHeader = css(_templateObject());
export var ModalTitle = css(_templateObject2());
export var ModalCloseButtonView = styled.div(_templateObject3(), ui.space(2));